import { render } from "./RepairAutomatic.vue?vue&type=template&id=060a777d"
import script from "./RepairAutomatic.vue?vue&type=script&lang=js"
export * from "./RepairAutomatic.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__